import React, { useState } from 'react';
import { Card, CardBody, Collapse, Row, Col } from 'reactstrap';

import Legislacao from '../Legislacao';

//Context
import { useAuth } from '../../../context/auth';

const getManuais = (caminhoVirtual) => [
    {
        title: "RCC- Manual Cadastro Transportador",
        link: caminhoVirtual + "RCCManualCadastroTransportador.pdf"
    },
    {
        title: "RCC - Manual Cadastro Gerador",
        link: caminhoVirtual + "RCCManualCadastroGerador.pdf"
    },
    {
        title: "RCC - Manual Cadastro Destino Final",
        link: caminhoVirtual + "RCCManualCadastroDestinoFinal.pdf"
    },
    {
        title: "RSS - ManualCadastro Gerador",
        link: caminhoVirtual + "RSSManualCadastroGerador.pdf"
    },
    {
        title: "RGG - Manual Cadastro Transportador",
        link: caminhoVirtual + "RGGManualCadastroTransportador.pdf"
    },
    {
        title: "RGG - Manual Cadastro Grande Gerador",
        link: caminhoVirtual + "RGGManualCadastroGrandeGerador.pdf"
    },
    {
        title: "RGG - Manual Cadastro Destino Final",
        link: caminhoVirtual + "RGGManualCadastroDestinoFinal.pdf"
    },
    {
        title: "Manual Taxa Fislurb",
        link: caminhoVirtual + "ManualTaxaFislurb.pdf"
    },
];

export default function Duvidas() {
    const { setupSistema } = useAuth();

    const [informacoes, setInformacoes] = useState([
        {
            title: "Quem precisa se cadastrar?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Devem realizar o cadastro junto à SP Regula, conforme a modalidade aplicável:
                    </p>
                    <ul>
                        <li>Grandes Geradores de Resíduos Sólidos (RGG): estabelecimentos que geram acima de 200 litros de resíduos por dia;</li>
                        <li>Condomínios não residenciais ou mistos: quando a soma dos resíduos gerados for superior a 1.000 litros por dia;</li>
                        <li>Grandes Geradores de Resíduos da Construção Civil (RCC): geradores com produção superior a 50 kg de resíduos por dia;</li>
                        <li>Pequenos e Grandes Geradores de Resíduos de Serviços de Saúde (RSS);</li>
                        <li>Transportadores de Resíduos: pessoas físicas ou jurídicas que possuam sede ou filial no Município de São Paulo, desde que realizem o transporte de resíduos sujeitos ao controle da SP Regula, podendo efetuar o cadastro junto à Agência;</li>
                        <li>Destinos Finais: empreendimentos licenciados para o recebimento, armazenamento, transbordo, tratamento, reciclagem ou destinação final de resíduos sujeitos ao controle da SP Regula.</li>
                    </ul>
                </div>
            ),
            collapse: false
        },
        {
            title: "Qual o custo para o cadastro?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Os valores dos preços públicos são atualizados anualmente por ato normativo do Município de São Paulo.
                    </p>
                    <p>
                        Conforme a Tabela de Preços Públicos de 2026, os valores são:
                    </p>
                    <ul>
                        <li>Geradores de Resíduos de Serviços de Saúde (RSS): cadastro novo ou renovação – R$ 158,00; atualização de dados – R$ 127,00.</li>
                        <li>Grandes Geradores de Resíduos Sólidos (RGG): cadastro novo ou renovação – R$ 328,00; atualização de dados – R$ 127,00.</li>
                        <li>Transportadores de Resíduos RCC – Pessoa Jurídica: cadastro novo ou renovação – R$ 396,00; atualização de dados – R$ 127,00.</li>
                        <li>Transportadores de Resíduos RCC – Pessoa Física: cadastro novo ou renovação – R$ 328,00; atualização de dados – R$ 127,00.</li>
                        <li>Transportadores de Resíduos RGG: cadastro novo ou renovação – R$ 168,00 por registro, acrescido de R$ 66,80 por veículo; atualização de dados – R$ 85,80 por registro, acrescido de R$ 66,80 por veículo.</li>
                        <li>Destino Final: cadastro novo ou renovação – R$ 394,00; atualização de dados – R$ 127,00.</li>
                    </ul>
                    <p>
                        Os demais valores podem ser consultados no Decreto nº 64.877/2025.
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Qual a penalidade para quem não se cadastrar?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        O responsável que deixar de cumprir as obrigações previstas na legislação, inclusive quando deixar de realizar o cadastro obrigatório junto à SP Regula, estará sujeito às sanções administrativas previstas na Lei nº 13.478/2002 e demais normas aplicáveis.
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Qual é a validade do cadastro pago para a SP Regula?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        A validade do cadastro varia conforme a modalidade:
                    </p>
                    <ul>
                        <li>Geradores de Resíduos de Serviços de Saúde (RSS): cadastro sem prazo de validade, devendo os dados permanecerem atualizados;</li>
                        <li>Grandes Geradores de Resíduos (RGG): 1 ano;</li>
                        <li>Transportadores de Resíduos: 1 ano;</li>
                        <li>Destinos Finais: 1 ano;</li>
                        <li>Grandes Geradores de RCC: 3 anos.</li>
                    </ul>
                    <p>
                        Ao término da validade, quando aplicável, deverá ser solicitada a renovação do cadastro.
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Sou um transportador com sede em outro município, mas transporto resíduos na capital. Devo me cadastrar junto à SP Regula?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Para o exercício da atividade de transporte de resíduos no Município de São Paulo, é obrigatório que o transportador possua sede ou filial estabelecida no Município, bem como o Ato de Registro de Funcionamento emitido pela Subprefeitura competente e os demais documentos exigidos no momento do cadastro, conforme legislação vigente.
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Minha empresa gera resíduos, mas ainda não tenho uma empresa de transportes para enviá-los para um destino autorizado. Como posso contratar este serviço?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        As listagens de todos os transportadores cadastrados, assim como Destinos Finais, podem ser encontradas em <a href="https://prefeitura.sp.gov.br/web/spregula/w/residuos_solidos/311649" target='_blank'>https://prefeitura.sp.gov.br/web/spregula/w/residuos_solidos/311649</a>.
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Onde me informo sobre a TRSS?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        A CCM e a Taxa de Resíduos Sólidos de Serviços de Saúde (TRSS) são de responsabilidade da Secretaria Municipal da Fazenda.
                    </p>
                    <p>
                        Orientamos que o interessado entre em contato por meio do Portal SP156 ou pelo telefone 156 para obter maiores informações, ou acesse o site da Secretaria Municipal da Fazenda: <a href="https://prefeitura.sp.gov.br/web/fazenda/w/servicos/taxaderesiduos/2366" target='_blank'>https://prefeitura.sp.gov.br/web/fazenda/w/servicos/taxaderesiduos/2366</a>.
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Sou um Grande Gerador localizado dentro de um condomínio. Devo me cadastrar?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Sim. O cadastro é obrigatório para todo estabelecimento que gere, em média, volume superior a 200 litros de resíduos por dia, ainda que esteja localizado dentro de um condomínio.
                    </p>
                    <p>
                        Nesses casos, deverão ser anexados ao cadastro o contrato firmado entre o condomínio e a empresa transportadora, bem como o contrato de locação (ou documento equivalente) que comprove o vínculo entre o estabelecimento gerador e o condomínio.
                    </p>
                    <p>
                        Ambos os documentos devem ser juntados no mesmo arquivo.
                    </p>
                </div>
            ),
            collapse: false
        },
    ]);

    //State para mostrar legislação
    const [mostrarLegislacao, setMostrarLegislacao] = useState(false);
    const [mostrarManual, setMostrarManual] = useState(false);

    const handleMostrarTexto = (index) => {
        setInformacoes(prevState => {
            const _mensagens = [...prevState];
            _mensagens[index] = { ..._mensagens[index], collapse: !_mensagens[index].collapse };
            return _mensagens;
        });
    }

    return <div className="content" style={{ marginTop: "40px" }}>
        {/* cabeçalho */}
        <div className={"d-flex justify-content-between align-items-center mb-0 pb-0"} style={{ color: "#666" }}>
            <div lg={11}>
                <h5 className='mb-0' style={{ fontWeight: "bold", marginTop: "10px" }}>Dúvidas sobre coleta e destinação de resíduos?</h5>
            </div>
            <div lg={1}>
                <div
                    className='d-flex justify-content-center align-items-center rounded-circle'
                    style={{
                        width: "50px",
                        height: "50px",
                        border: "3px solid #666",
                        background: "transparent"
                    }}
                >
                    <div style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#666"
                    }}>
                        ?
                    </div>
                </div>
            </div>
        </div>
        <div className="mt-0">
            <hr style={{ border: "2px solid #666" }} />
        </div>

        {/* Topicos */}
        <div className='row' style={{ color: "#666" }}>

        <div className="col-sm-12 my-2">
                <div className='d-flex justify-content-between align-items-center'>
                    <h6 className='fw-bold'>Manuais</h6>
                    <div style={{ border: "2px solid #666", width: "30px", marginTop: "4px" }}></div>
                </div>

                <div
                    className='mb-2 rounded p-2 d-flex justify-content-between align-items-center'
                    style={{ background: "#b6b3b3" }}
                    type={"button"}
                    onClick={() => setMostrarManual(!mostrarManual)}
                >
                    <h6 className='mb-0 text-white' >Mostrar todos os manuais</h6>
                    <i className="fas fa-cloud-download-alt text-white"></i>
                </div>
                {mostrarManual &&
                    getManuais(setupSistema?.caminhoVirtual ?? '').map((value, index) => {
                        return <div className='mt-2'>
                            <div key={index} className=' mb-2 rounded p-2' style={{ border: "2px solid #b6b3b3", background: "rgb(226, 218, 218)" }}>
                                <div className='d-flex align-items-center justify-content-between w-100'
                                    type="button"
                                    onClick={() => window.open(value.link, "_blank")}
                                >
                                    <h6 className='mb-0' style={{ fontWeight: "normal" }}>{value.title}</h6>
                                    <i className="fas fa-file-alt"></i>
                                </div>
                            </div>
                        </div>
                    })
                }
            </div>

            <div className="col-sm-12 my-2">
                <div className='d-flex justify-content-between align-items-center'>
                    <h6 className='fw-bold'>Dúvidas</h6>
                    <div style={{ border: "2px solid #666", width: "30px", marginTop: "4px" }}></div>
                </div>
                {/* Conteudo */}
                {informacoes.map((value, index) => {
                    if(value.link == null)
                    {
                        const Component = value.texto;
                        return <div key={index} className=' mb-2 rounded p-2' style={{ border: "2px solid #b6b3b3" }}>
                            <div className='d-flex align-items-center justify-content-between w-100'
                                type="button"
                                onClick={() => handleMostrarTexto(index)}
                            >
                                <h6 className='mb-0' style={{ fontWeight: informacoes[index].collapse ? "bold" : "normal" }}>{value.title}</h6>
                                {informacoes[index].collapse ? <i className="fas fa-angle-up"></i> : <i className="fas fa-angle-down"></i>}
                            </div>
                            <Collapse isOpen={value.collapse} className="mt-2">
                                <Component />
                            </Collapse>
                        </div>
                    } else {
                        return <div key={index} className=' mb-2 rounded p-2' style={{ border: "2px solid #b6b3b3", background: "rgb(226, 218, 218)" }}>
                                <div className='d-flex align-items-center justify-content-between w-100'
                                    type="button"
                                    onClick={() => window.open(value.link, "_blank")}
                                >
                                    <h6 className='mb-0' style={{ fontWeight: "normal" }}>{value.title}</h6>
                                    <i className="fas fa-file-alt"></i>
                                </div>
                            </div>
                    }
                })}
            </div>

            <div className="col-sm-12 my-2">
                <div className='d-flex justify-content-between align-items-center'>
                    <h6 className='fw-bold'>Legislações</h6>
                    <div style={{ border: "2px solid #666", width: "30px", marginTop: "4px" }}></div>
                </div>

                <div
                    className='mb-2 rounded p-2 d-flex justify-content-between align-items-center'
                    style={{ background: "#b6b3b3" }}
                    type={"button"}
                    onClick={() => setMostrarLegislacao(!mostrarLegislacao)}
                >
                    <h6 className='mb-0 text-white' >Mostrar todas as legislações</h6>
                    <i className="fas fa-cloud-download-alt text-white"></i>
                </div>
                {mostrarLegislacao &&
                    <Legislacao />
                }
            </div>

        </div>

        {/* Contato WhatsApp SP Regula */}
        <Row className="mt-4 mb-3">
            <Col lg="12">
                <Card
                    style={{
                        background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                        borderRadius: "12px",
                        border: "none",
                        boxShadow: "0 4px 20px rgba(37,211,102,0.3)"
                    }}
                >
                    <CardBody>
                        <Row className="align-items-center">
                            <Col lg="8" md="7" sm="12" className="text-white">
                                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                                    <i
                                        className="fab fa-whatsapp"
                                        style={{ fontSize: "2.2em", display: "flex", alignItems: "center", lineHeight: 1 }}
                                    />
                                    <h4 className="mb-0 font-weight-bold" style={{ color: "#fff", margin: 0, lineHeight: 1 }}>
                                        Atendimento via WhatsApp
                                    </h4>
                                </div>
                                <p style={{ color: "rgba(255,255,255,0.9)", marginBottom: "14px" }}>
                                    Gestão de Saneamento Ambiental.
                                </p>
                                <a
                                    href="https://wa.me/551133967901"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        backgroundColor: "#fff",
                                        color: "#128C7E",
                                        padding: "10px 22px",
                                        borderRadius: "30px",
                                        fontWeight: "bold",
                                        fontSize: "1em",
                                        textDecoration: "none",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                        transition: "transform 0.15s ease, box-shadow 0.15s ease"
                                    }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.transform = "scale(1.04)";
                                        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.22)";
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.transform = "scale(1)";
                                        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                                    }}
                                >
                                    <i className="fab fa-whatsapp mr-2" style={{ fontSize: "1.3em" }} />
                                    (11) 3396-7901
                                </a>
                                <p style={{ color: "rgba(255,255,255,0.85)", marginTop: "10px", marginBottom: 0, fontSize: "0.88em", fontStyle: "italic" }}>
                                    Atendimento exclusivo para Cadastros
                                </p>
                                <div className="mt-3">
                                    <p style={{ color: "rgba(255,255,255,0.9)", fontSize: "0.95em", marginBottom: "6px", fontWeight: "bold" }}>
                                        Contatos via E-mail:
                                    </p>
                                    <div>
                                        <a href="mailto:cadastroderesiduos@spregula.sp.gov.br" style={{ color: "#fff", fontSize: "0.92em", textDecoration: "underline", display: "block", marginBottom: "4px" }}>
                                            <i className="far fa-envelope mr-1" /> cadastroderesiduos@spregula.sp.gov.br
                                        </a>
                                        <a href="mailto:assessoriaderesiduos@spregula.sp.gov.br" style={{ color: "#fff", fontSize: "0.92em", textDecoration: "underline", display: "block" }}>
                                            <i className="far fa-envelope mr-1" /> assessoriaderesiduos@spregula.sp.gov.br
                                        </a>
                                    </div>
                                </div>
                            </Col>
                            <Col
                                lg="4" md="5" sm="12"
                                className="text-center mt-3 mt-md-0"
                            >
                                <p style={{ color: "rgba(255,255,255,0.85)", marginBottom: "6px", fontSize: "0.85em" }}>
                                    Ou escaneie o QR Code:
                                </p>
                                <div
                                    style={{
                                        display: "inline-block",
                                        background: "#fff",
                                        borderRadius: "10px",
                                        padding: "8px",
                                        boxShadow: "0 2px 12px rgba(0,0,0,0.18)"
                                    }}
                                >
                                    <img
                                        src="/whatsapp-qrcode.png"
                                        alt="QR Code WhatsApp Atendimento"
                                        style={{ width: "130px", height: "130px", display: "block", borderRadius: "6px" }}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Row>

    </div>;

}